
import TableApp from "@/components/Table/Table2";
import crmService from "@/modules/CRM/services/crmService";

export default {
  name: "crm-contatos",
  components: { TableApp },
  data() {
    return {
      form: this.emptyForm(),
      fields: [
        { label: "Nome", field: "nome", filterOptions: { enabled: true } },
        {
          label: "Telefone",
          field: "telefone",
          filterOptions: { enabled: true },
        },
        { label: "E-mail", field: "email", filterOptions: { enabled: true } },
        { label: "Status", field: "status", filterOptions: { enabled: true } },
        { label: "Responsável", field: "usuario" },
      ],
    };
  },
  methods: {
    emptyForm() {
      return {
        nome: "",
        telefone: "",
        email: "",
        observacoes: "",
      };
    },
    abrirModal() {
      this.form = this.emptyForm();
      this.$bvModal.show("crm-contato-modal");
    },
    async salvar() {
      await crmService.criarContato(this.form);
      this.$toast.success("Contato criado com sucesso.");
      this.$bvModal.hide("crm-contato-modal");
      this.$refs.tabela.refresh();
    },
  },
};
